let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f1gvW")).then(() => parcelRequire('iM8xS'));